import { render, staticRenderFns } from "./mrecBannerTop.vue?vue&type=template&id=e47ea16a&scoped=true&"
import script from "./mrecBannerTop.vue?vue&type=script&lang=js&"
export * from "./mrecBannerTop.vue?vue&type=script&lang=js&"
import style0 from "./mrecBannerTop.vue?vue&type=style&index=0&id=e47ea16a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e47ea16a",
  null
  
)

export default component.exports